module.exports = __webpack_public_path__ + "media/customizations/tavolalife/logo-new-4496dadde005404c5988a6283577a3e6.png";